import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthShell, { googleLogin } from "../components/AuthShell";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";

const input = "w-full border border-linen bg-white px-4 py-3 text-sm outline-none focus:border-pitch transition-colors";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setError(""); setLoading(true);
    try { await register(form.name, form.email, form.password); navigate("/account"); }
    catch (err) { setError(formatApiError(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <AuthShell title="Create Account" subtitle="Join the archive"
      footer={<>Already have an account? <Link to="/login" className="text-pitch border-b border-pitch pb-0.5">Sign in</Link></>}>
      <form onSubmit={submit} className="space-y-4">
        {error && <div className="bg-vermilion/10 border border-vermilion/30 text-vermilion text-sm px-4 py-3" data-testid="register-error">{error}</div>}
        <input required placeholder="Full name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className={input} data-testid="register-name" />
        <input required type="email" placeholder="Email address" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className={input} data-testid="register-email" />
        <input required type="password" placeholder="Password (min 6 characters)" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className={input} data-testid="register-password" />
        <button type="submit" disabled={loading} data-testid="register-submit"
          className="w-full bg-pitch text-ivory text-xs font-mono uppercase tracking-[0.2em] py-4 hover:bg-charcoal transition-colors disabled:opacity-50">
          {loading ? "Creating account…" : "Create Account"}
        </button>
      </form>
      <div className="flex items-center gap-4 my-6"><span className="flex-1 h-px bg-linen" /><span className="text-xs text-stonemuted uppercase tracking-widest">or</span><span className="flex-1 h-px bg-linen" /></div>
      <button onClick={googleLogin} data-testid="register-google"
        className="w-full border border-pitch text-xs font-mono uppercase tracking-[0.2em] py-4 hover:bg-pitch hover:text-ivory transition-colors">Continue with Google</button>
    </AuthShell>
  );
}
